import React from 'react';
import DashboardOperations from './DashboardOperations';

const DashBoardLayerOne = () => <DashboardOperations />;

export default DashBoardLayerOne;
